export const indicationsTemplate = `
<div
  id=":vc"
  class="ii gt"
  jslog="20277; u014N:xr6bB; 1:WyIjdGhyZWFkLWY6MTc3ODM5MDk4ODU3OTM2MjA1OHxtc2ctZjoxNzc4MzkwOTg4NTc5MzYyMDU4IixudWxsLG51bGwsbnVsbCxudWxsLG51bGwsbnVsbCxudWxsLG51bGwsbnVsbCxudWxsLG51bGwsbnVsbCxbXV0.; 4:WyIjbXNnLWY6MTc3ODM5MDk4ODU3OTM2MjA1OCIsbnVsbCxbXSxudWxsLG51bGwsbnVsbCxudWxsLG51bGwsbnVsbCxudWxsLG51bGwsbnVsbCxudWxsLG51bGwsbnVsbCxbXSxbXSxbXV0."
  ><div id=":os" class="a3s aiL msg5094942471179559977"
    ><u></u>

    <div
      style="
        box-sizing: border-box;
        font-weight: 400;
        font-size: 10pt;
        font-family: 'Montserrat', sans-serif;
        background: #F5F0FF;
        margin: 0 auto;
      ">
      <table
        class="m_5094942471179559977main-area"
        border="0"
        style="
          box-sizing: border-box;
          width: 800px;
          margin: 0px auto;
          font-size: 10pt;
          background: #F5F0FF;
          padding: 0 24px 24px;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
        "
        ><tbody style="box-sizing: border-box">
          <tr style="box-sizing: border-box; display: none"><th style="box-sizing: border-box"></th></tr>
          <tr style="box-sizing: border-box">
            <td style="box-sizing: border-box; width: 100%">
              <table style="box-sizing: border-box; width: 100%"
                ><tbody style="box-sizing: border-box">
                  <tr style="box-sizing: border-box; display: none"><th style="box-sizing: border-box"></th></tr>
                  <tr style="box-sizing: border-box">
                    <td style="box-sizing: border-box; padding: 24px 0px; vertical-align: top; width: 50%">
                      <a
                        href="https://r.emma.ucchristus.cl/tr/cl/pzV4r3nTy15u8O5ta8cnjtl_9agZ95ZDlB_enx2Sn1OaaZg5IOOMPGZi7vAn13UHKJ7Xdk2szaNO6Kcb_A4dVHU_WfOdYdzIPljahpZ8oe2WLUv--oBln9PU2kJiC4tDVWoNIOJkdR_-xcwE_ygvy7ub3NHu-_UfHp-7VULfFqUqeU1ZIfSD6P5VAAdEn4CYvMkO1iEvM941iZ4OMEy9thox6FX4EQ"
                        rel="noopener"
                        style="box-sizing: border-box"
                        target="_blank"
                        data-saferedirecturl="https://www.google.com/url?q=https://r.emma.ucchristus.cl/tr/cl/pzV4r3nTy15u8O5ta8cnjtl_9agZ95ZDlB_enx2Sn1OaaZg5IOOMPGZi7vAn13UHKJ7Xdk2szaNO6Kcb_A4dVHU_WfOdYdzIPljahpZ8oe2WLUv--oBln9PU2kJiC4tDVWoNIOJkdR_-xcwE_ygvy7ub3NHu-_UfHp-7VULfFqUqeU1ZIfSD6P5VAAdEn4CYvMkO1iEvM941iZ4OMEy9thox6FX4EQ&amp;source=gmail&amp;ust=1697310166219000&amp;usg=AOvVaw2CR0SsXKODMlXzJhnOKuby"
                        ><img
                          class="m_5094942471179559977top-logo CToWUd"
                          border="0"
                          width="220"
                          height="48"
                          src="https://www.ucchristus.cl/assets/images/logo.png"
                          style="box-sizing: border-box; border: 0; mix-blend-mode: multiply"
                          data-bit="iit"
                      /></a>
                    </td>
                
                  </tr> </tbody
              ></table>
            </td>
          </tr>
          <tr style="box-sizing: border-box">
            <td
              style="
                box-sizing: border-box;
                width: 100%;
                background: #fff;
                border-radius: 16px;
                border: 1px solid #e0e3e5;
              ">
              <table
                class="m_5094942471179559977bg-props"
                style="
                  box-sizing: border-box;
                  width: 100%;
                  padding: 24px;
                  border-radius: 16px 16px 0 0;
                  background: url(https://s3.us-west-2.amazonaws.com/recursosweb.pub.prd.usw2/correos/banner1.png);
                  background-repeat: no-repeat;
                  background-position: center;

                "
                ><tbody style="box-sizing: border-box">
                  <tr style="box-sizing: border-box; display: none"><th style="box-sizing: border-box"></th></tr>
                  <tr style="box-sizing: border-box">
                    <td
                      style="
                        box-sizing: border-box;
                        padding-bottom: 0px;
                        padding-top: 0px;
                        vertical-align: top;
                        width: 100%;
                        text-align: left;
                      ">
                        <br><br><br><br><br>
                    </td>
                  </tr>
                </tbody></table
              >
              <table
                class="m_5094942471179559977inerr"
                style="box-sizing: border-box; width: 100%; padding: 24px 24px 0">
                <tbody
                  ><tr style="box-sizing: border-box; display: none"><th style="box-sizing: border-box"></th></tr>
                  <tr style="box-sizing: border-box">
                    <td style="box-sizing: border-box; width: 100%">
                      <table
                        style="
                          box-sizing: border-box;
                          width: 100%;
                          padding: 24px 24px;
                          background: #e1f2ff;
                          border-radius: 16px;
                        "
                        ><tbody style="box-sizing: border-box">
                          <tr style="box-sizing: border-box; display: none"
                            ><th style="box-sizing: border-box"></th
                          ></tr>
                          <tr style="box-sizing: border-box">
                            <td
                              class="m_5094942471179559977plr2"
                              style="
                                box-sizing: border-box;
                                padding-bottom: 0px;
                                padding-top: 0px;
                                padding-left: 20px;
                                vertical-align: top;
                                width: 33%;
                                text-align: left;
                              ">
                              <p
                                style="
                                  box-sizing: border-box;
                                  font-size: 14px;
                                  font-weight: 400;
                                  color: #373737;
                                  margin-bottom: 0px;
                                  margin-top: 0;
                                  display: flex;
                                "
                                ><span
                                  class="m_5094942471179559977cl-text"
                                  style="
                                    box-sizing: border-box;
                                    font-weight: 700;
                                    font-size: 17px;
                                    line-height: 24px;
                                    color: #373737;
                                  "
                                  >  Paciente
                                  <br style="box-sizing: border-box" />
                                  <strong
                                    class="m_5094942471179559977cl-s"
                                    style="
                                      box-sizing: border-box;
                                      font-weight: 400;
                                      font-size: 16px;
                                      line-height: 20px;
                                      color: #373737;
                                    "
                                    >  $patientFullname$
                                    </strong
                                  >
                                  </span
                                ></p
                              >
                            </td>
                            <td
                              class="m_5094942471179559977plr2"
                              style="
                                box-sizing: border-box;
                                padding-bottom: 0px;
                                padding-top: 0px;
                                padding-left: 20px;
                                vertical-align: center;
                                width: 33%;
                                text-align: left;
                              ">
                              <p
                                style="
                                  box-sizing: border-box;
                                  font-size: 14px;
                                  font-weight: 400;
                                  color: #373737;
                                  margin-bottom: 0px;
                                  margin-top: 0;
                                  display: flex;
                                "
                                ><span
                                  class="m_5094942471179559977cl-text"
                                  style="
                                    box-sizing: border-box;
                                    font-weight: 700;
                                    font-size: 17px;
                                    line-height: 24px;
                                    color: #373737;
                                  "
                                  >
                                    
                                  Médico tratante
                                    <br style="box-sizing: border-box" />
                                    <strong
                                    class="m_5094942471179559977cl-s"
                                    style="
                                      box-sizing: border-box;
                                      font-weight: 400;
                                      font-size: 16px;
                                      line-height: 20px;
                                      color: #373737;
                                    "
                                    >   $professionalFullname$
                                  </strong> 
                                  </span
                                ></p
                              >
                            </td>
                            <td
                            class="m_5094942471179559977plr2"
                            style="
                              box-sizing: border-box;
                              padding-bottom: 0px;
                              padding-top: 0px;
                              padding-left: 20px;
                              vertical-align: center;
                              width: 33%;
                              text-align: left;
                            ">
                            <p
                              style="
                                box-sizing: border-box;
                                font-size: 14px;
                                font-weight: 400;
                                color: #373737;
                                margin-bottom: 0px;
                                margin-top: 0;
                                display: flex;
                              "
                              ><span
                                class="m_5094942471179559977cl-text"
                                style="
                                  box-sizing: border-box;
                                  font-weight: 700;
                                  font-size: 17px;
                                  line-height: 24px;
                                  color: #373737;
                                "
                                >
                                  
                                Área de consulta
                                  <br style="box-sizing: border-box" />
                                  <strong
                                  class="m_5094942471179559977cl-s"
                                  style="
                                    box-sizing: border-box;
                                    font-weight: 400;
                                    font-size: 16px;
                                    line-height: 20px;
                                    color: #373737;
                                  "
                                  >  $professionalSpecialty$
                                </strong> 
                                </span
                              ></p
                            >
                          </td>
                          </tr>
                        </tbody></table
                      >
                    </td>
                  </tr>
                </tbody></table
              >
              <table class="m_5094942471179559977inerr" style="box-sizing: border-box; width: 100%; padding: 0px 24px">
                <tbody
                  ><tr style="box-sizing: border-box; display: none"><th style="box-sizing: border-box"></th></tr>
                  <tr style="box-sizing: border-box">
                    <td style="box-sizing: border-box; width: 100%">
                      <table
                        class="m_5094942471179559977tplr"
                        style="
                          box-sizing: border-box;
                          width: 100%;
                          background: #F5F0FF;
                          border-radius: 16px;
                          margin: 16px 0px;
                      
                        "
                        >
                        <tbody style="box-sizing: border-box">
                      
                          $linksButtons$

                          $informationMessage$

                          <tr> <td> &nbsp; </td> </tr>
                          </tbody
                      ></table>

                      
                      
                    </td>
                  </tr>
                  <tr>
                    <td>
                      
                    </td>
                  </tr>
                  <tr>
                  <tr style="box-sizing: border-box">
                    <td style="box-sizing: border-box; width: 100%">
                      <table
                        style="
                          box-sizing: border-box;
                          width: 100%;
                          padding: 24px 24px;
                          background: #e1f2ff;
                          border-radius: 16px;
                        "
                        ><tbody style="box-sizing: border-box">
                          <tr style="box-sizing: border-box; display: none"
                            ><th style="box-sizing: border-box"></th
                          ></tr>
                          <tr style="box-sizing: border-box">
                            <td
                              style="
                                box-sizing: border-box;
                                padding-bottom: 0px;
                                padding-top: 20px;
                                padding-left: 20px;
                                vertical-align: top;
                                width: 30%;
                                text-align: left;
                              ">
                              <img
                                src="https://portal-indicaciones-front-prd.s3.us-east-1.amazonaws.com/assets/img/medical-team.png"
                                alt="image"
                                style="box-sizing: border-box"
                                class="CToWUd"
                                data-bit="iit"
                                width="120" />
                            </td>
                            <td
                              style="
                                box-sizing: border-box;
                                padding-bottom: 0px;
                                padding-top: 0px;
                                padding-left: 0px;
                                vertical-align: center;
                                width: 70%;
                                text-align: left;
                              ">
                         
                              <h4
                                style="
                                  box-sizing: border-box;
                                  font-weight: 700;
                                  font-size: 16px;
                                  line-height: 20px;
                                  color: #373737;
                                  margin: 0;
                                  margin-bottom: 10px;
                                "
                                >Información</h4
                              >

                              <p style="box-sizing: border-box; margin-bottom: 8px; margin-top: 0; display: flex;text-align: justify;"
                                ><span style="box-sizing: border-box; font-weight: 400; font-size: 14px; color: #373737">
                                Recuerda que en centros médicos tenemos convenios FONASA e Isapre para exámenes y procedimientos. <br><br>
                                  Además con el servicio UC CHRISTUS en casa, llegamos a tu domicilio con Toma de Muestra Kinesioterapia,
                                  procedimientos de enfermería y de especialidades, entre otras prestaciones.
                                  Contáctanos al 2 2354 3005 o al mail ucencasa@ucchristus.cl, para recibir la Medicina UC en la seguridad de tu hogar.</span
                                ></p
                              >
                           

                         
                            </td>
                          </tr>
                      
                        </tbody>
                        </table >
                        
                    </td>
                  </tr>
                  <tr><td>
                    &nbsp;</td></tr>
                
                  
                  <tr><td>&nbsp;</td></tr> 
                  
                  </tbody
              >
      
            </table>
     
           
             
            </td>
          </tr>
        </tbody>
        <table
        style="
          box-sizing: border-box;
          width: 100%;
          background-image: cover;
          padding: 30px;
          background: url( https://s3.us-west-2.amazonaws.com/recursosweb.pub.prd.usw2/correos/somos-uc.png);
          background-repeat: no-repeat;
          width: 750px;
         margin: 0 auto;
        "
        >
       </table>
        </table
      >
    </div
    ><div class="yj6qo"></div><div class="adL"> </div></div
></div>



`;

export const examButtonHeaderPartial = `
<tr style='box-sizing: border-box'>
  <th colspan='2' style='
      box-sizing: border-box;
      text-align: center;
      padding: 16px 0 12px;
      border-radius: 16px 16px 0 0;
      background: #9062F4;
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      text-transform: uppercase;
      color: #ffffff;'>
    LISTADO DE INDICACIONES MÉDICAS
  </th>
</tr>
$items$
`;

export const examButtonLinkPartial = `
<tr style='box-sizing:border-box'>
  <td style='
      box-sizing: border-box;
      padding: 24px 10px 0 60px;
      vertical-align: top;
      width: 50%;
      text-align: left;'>
    <p style='
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #373737;
        margin-bottom: 0;
        margin-top: 0;
        display: flex;'>
      <span style='box-sizing: border-box; font-weight: 600; font-size: 16px; color: #373737'>
        $serviceName$ <br style='box-sizing:border-box'/>
        <strong style='box-sizing: border-box;font-weight: 400;font-size: 14px;line-height: 20px;color: #373737;'>
          $codFonasa$
        </strong>
      </span>
    </p>
  </td>
  <td style='
      box-sizing: border-box;
      padding: 24px 30px 0 60px;
      vertical-align: top;
      width: 50%;
      text-align: left;'>
    <p style='
        box-sizing: border-box;
        color: #373737;
        margin-bottom: 0;
        margin-top: 0;
        display: flex;
      '>
      <span style='box-sizing: border-box; font-weight: 400; font-size: 16px; color: #373737'>
        <a href='$link$' 
          style='background-color:#fff; border-radius:10px; border:1px solid #9062F4; padding: 10px 30px 10px 30px; text-decoration:none;'>
          Agendar aquí
        </a>
      </span>
    </p>
  </td>
</tr>
`;

export const examButtonDirectPartial = `
<tr style='box-sizing: border-box'>
  <td style='
      box-sizing: border-box;
      padding: 24px 10px 20px 60px;
      vertical-align: top;
      width: 50%;
      text-align: left;'>
    <p style='
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #373737;
        margin-bottom: 0px;
        margin-top: 0;
        display: flex;'>
      <span style='box-sizing: border-box; font-weight: 600; font-size: 16px; color: #373737'>
        $serviceName$
        <br style='box-sizing: border-box'/>
        <strong style='
            box-sizing: border-box;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #373737;'>
          $codFonasa$
        </strong>
      </span>
    </p>
  </td>
  <td style='
      box-sizing: border-box;
      padding: 24px 30px 20px 60px;
      vertical-align: top;
      width: 50%;
      text-align: left;'>
    <p style='
        box-sizing: border-box;
        color: #373737;
        margin-bottom: 0;
        margin-top: 0;
        display: flex;'>
      <span style='box-sizing: border-box; font-weight: 600; font-size: 16px; color: #373737'>
        No necesitas agendar hora, la atención es por orden de llegada.
      </span>
      </p>
  </td>
</tr>`;
export const examButtonCallPartial = `
<tr style='box-sizing: border-box'>
  <td style='
      box-sizing: border-box;
      padding: 24px 10px 20px 60px;
      vertical-align: top;
      width: 50%;
      text-align: left;'>
    <p style='
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #373737;
        margin-bottom: 0;
        margin-top: 0;
        display: flex;'>
      <span style='box-sizing: border-box; font-weight: 600; font-size: 16px; color: #373737'>
        $serviceName$
        <br style='box-sizing: border-box' />
        <strong style='
            box-sizing: border-box;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #373737;'>
            $codFonasa$
        </strong>
      </span>
    </p>
  </td>
  <td style='
      box-sizing: border-box;
      padding: 24px 30px 0 60px;
      vertical-align: top;
      width: 50%;
      text-align: left;'>
    <p style='
        box-sizing: border-box;
        color: #373737;
        margin-bottom: 0;
        margin-top: 0;
        display: flex;'>
      <span style='box-sizing: border-box; font-weight: 600; font-size: 16px; color: #373737'>
        Reserva tu hora llamando a <a href='tel:226767000'>226767000</a>
      </span>
      </p>
  </td>
</tr>
`;
